/* eslint-disable no-restricted-imports -- firebase compat: 新たにコードを追加する時は modular API を使う。modular API へ移行したらこのコメントごと削除する */
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
/* eslint-enable no-restricted-imports */

/**
 * check if user has email provider data
 * @param user
 */
export const hasEmailProviderData = (user: firebase.User): boolean => {
  const havingProviderIdList = user.providerData.map(
    // @ts-expect-error TS18047
    (provider) => provider.providerId
  );
  return havingProviderIdList.includes(
    firebase.auth.EmailAuthProvider.PROVIDER_ID
  );
};

/**
 * ログインに使えるプロバイダだけを返す。
 * 電話番号は本人確認のために紐付けるだけで、portal に電話番号でログインする画面は無い。
 * docomo / FANY ID はカスタムトークンでログインするため providerData に現れない。
 */
export const getSignInProviderData = (
  user: firebase.User
): firebase.UserInfo[] =>
  user.providerData.filter(
    (provider): provider is firebase.UserInfo =>
      provider !== null &&
      provider.providerId !== firebase.auth.PhoneAuthProvider.PROVIDER_ID
  );

/**
 * check if user need reauth
 * @param user
 */
export const isReAuthRequiredToEditAddress = (
  user: firebase.User,
  isWhenPageEnter = false
): boolean => {
  // @ts-expect-error TS2769
  const lastSignInTime = new Date(user.metadata.lastSignInTime);
  const now = new Date();
  // 登録APIの再認証要求までの時間は30分だが、
  // 再認証後に登録処理を行ってもらうようにするためフロントは短めにする。
  // isWhenPageEnter 判定はなるべくページに入ったら再認証をしてもらうようにするため
  // 時間を延ばした経緯: https://github.com/balus-co-ltd/spwn-web/issues/274
  const reauthRequirationSeconds = isWhenPageEnter ? 900 : 1500;
  return (
    lastSignInTime.getTime() + reauthRequirationSeconds * 1000 < now.getTime()
  );
};
